import styled from 'styled-components';

import { Loader } from '@src/components/Loader';

export const Header = styled.h1`
  font-size: ${({ theme }) => theme.fontSizeBig}rem;
`;

export const ConnectionFailureMessage = styled.p`
  margin-bottom: 40px;
`;

export const ModalLoader = styled(Loader)`
  margin: 20px auto;
`;

export const Support = styled.div`
  margin: 0 auto;
  font-size: ${({ theme }) => theme.fontSizeDefault}rem;
`;

export const SupportDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing4}px;

  a,
  span {
    display: inline-block;

    + span {
      margin-left: ${({ theme }) => theme.spacing24}px;
    }
  }

  a:focus {
    outline: none;
  }
`;
